import React, { useEffect, useState } from "react";
import * as ReactDOMClient from 'react-dom/client';
import Spinner from "../Common/Spinner";
import TeamAccordion from "./Team";
import { TeamsContext } from "./TeamsContext";
import { MissionService } from "@/common/api/Services/Mission";
export default function ManageTeams() {
    const [pageStatus, setPageStatus] = useState("loading");
    const [teams, setTeams] = useState();
    //@ts-ignore
    const missionId = window.missionId;
    const getTeams = async () => {
        try {
            const res = await MissionService.getTeams(missionId);
            setTeams(res);
            setPageStatus("success");
        }
        catch {
            setPageStatus("error");
        }
    };
    useEffect(() => {
        getTeams();
    }, []);
    if (pageStatus === "loading") {
        return React.createElement(Spinner, null);
    }
    if (pageStatus === "error") {
        return React.createElement("h2", { className: 'text-center' }, "an error occurred");
    }
    if (!teams) {
        return React.createElement(React.Fragment, null);
    }
    if (teams.length <= 0) {
        return (React.createElement("p", { className: 'my-4' }, "There are no existing users - start inviting people!"));
    }
    return (React.createElement(TeamsContext.Provider, { value: teams },
        React.createElement("div", { className: 'team-list mt-4' }, teams?.map((team) => (React.createElement(TeamAccordion, { key: team.id, team: team, missionId: missionId }))))));
}
const rctManageTeams = document.getElementById("rct-manageteams");
if (rctManageTeams !== null) {
    ReactDOMClient.createRoot(rctManageTeams).render(React.createElement(ManageTeams, null));
}
